import { ReferenceField, FunctionField, useRecordContext, Labeled } from 'react-admin';
import { Typography } from '@mui/material';
import { EventType, Event } from '../../types';

interface WizardActionContentProps {
  record?: Event;
  eventType: EventType;
  eventTypes: string[];
}

const WizardActionContent = ({ eventType, eventTypes, record }: WizardActionContentProps) => {
  if (!record?.rawContent) return null;
  if (!eventTypes.includes(eventType.name)) return null;

  try {
    const rawData = JSON.parse(record.rawContent);
    const action = rawData?.fields?.action;

    if (!action) return null;

    return (
      <Labeled label="Action">
        <Typography variant="body1" sx={{ textTransform: 'uppercase' }}>
          {action}
        </Typography>
      </Labeled>
    );
  } catch {
    // Error parsing rawContent, silently ignore
    return null;
  }
};

interface WizardActionProps {
  eventTypes?: string[];
}

export const WizardAction = ({
  eventTypes = ['nozzle-replacement-wizard', 'change-extruder-wizard'],
}: WizardActionProps) => {
  const record = useRecordContext<Event>();
  return (
    <ReferenceField source="eventTypeId" reference="event-types" link={false}>
      <FunctionField
        render={(eventType: EventType) => (
          <WizardActionContent record={record} eventType={eventType} eventTypes={eventTypes} />
        )}
      />
    </ReferenceField>
  );
};
